export default httpClient => ({
  save: async ({ conto, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.post('/contos', conto, { headers });
    return {
      data: response.data
    }
  },
  update: async ({ conto, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.put('/contos/' + conto.id, conto, { headers });
    return {
      data: response.data
    }
  },
  getById: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/contos/' + id, { headers });
    return {
      data: response.data
    }
  },
  getAll: async ({ token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.get('/contos', { headers });
    return {
      data: response.data
    }
  },
  delete: async ({ id, token }) => {
    const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
    const response = await httpClient.delete('/contos/' + id, { headers });
    return {
      data: response
    }
  },
  // deletarImagem: async ({ token }) => {
  //   const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
  //   const response = await httpClient.post('/excluir-imagens-contos', { headers });
  //   return {
  //     data: response
  //   }
  // },
  deletarImagens: async ({ token, imagens }) => {
    const headers = {
      "Authorization": "Bearer " + token
    }
    const response = await httpClient.post('/excluir-imagens-contos',
      {
        imagens
      }, { headers })
    return { data: response }
  },
  salvarImagem: async ({ token, formImagem }) => {
    let headers = { "Authorization": "Bearer " + token, "Content-Type": "multipart/form-data" }
    const response = httpClient.post('/imagens-contos', formImagem, { headers })
    return {
      data: response.data,
    }
  },
  getAllSite: async ({ num_pagina }) => {
    const response = await httpClient.get('/contos-site/' + num_pagina);
    return { data: response.data }
  },
  getContoSite: async ({ titulo_url }) => {
    const response = await httpClient.get('/conto/' + titulo_url);
    return { data: response.data }
  },
});